import React from 'react'
import { ShiftBadge, ShiftBadges } from 'ui'
import { useValue } from '@morningtrain/react-resources'

export default function Badges (props) {
  const {
    name = 'badges',
    big = false,
    bigger = false
  } = props

  const badges = useValue(name)

  if (!badges) {
    return null
  }

  const badgeSlugs = Object.keys(badges)

  if (!badgeSlugs || !badgeSlugs.length) {
    return null
  }

  return (
    <ShiftBadges>
      {badgeSlugs.map(badgeSlug => {
        return (
          <ShiftBadge
            key={badgeSlug}
            slug={badgeSlug}
            title={badges[badgeSlug]}
            big={big}
            bigger={bigger}
          />
        )
      })}
    </ShiftBadges>
  )
}
